const ProfileSvg = () => (
  <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="84" height="84" rx="42" fill="#F4F5F6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.8682 25.681C51.1096 28.9224 51.1096 34.1776 47.8682 37.419C44.6269 40.6603 39.3716 40.6603 36.1302 37.419C32.8889 34.1776 32.8889 28.9224 36.1302 25.681C39.3716 22.4397 44.6269 22.4397 47.8682 25.681Z"
      fill="#E4E7E9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 46.1836C51.4875 46.1836 60.75 50.2815 60.75 56.5836V58.6669C60.75 59.8169 59.8167 60.7503 58.6667 60.7503H25.3333C24.1833 60.7503 23.25 59.8169 23.25 58.6669V56.5836C23.25 50.2794 32.5125 46.1836 42 46.1836Z"
      fill="#E4E7E9"
    />
  </svg>
);

export default ProfileSvg;
